module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-content"
  }, [_c('banner', {
    attrs: {
      "url": "purchase",
      "hasDivider": "",
      "clazz": "purchase-banner"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('caigou-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "purchase-section1"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('img', {
    staticClass: "section1-img",
    attrs: {
      "src": require("../../assets/img/purchase/section1.png"),
      "alt": "通过采购，助力公司战略执行"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-misc"
  }, [_c('h1', {
    staticClass: "misc-title"
  }, [_vm._v("通过采购，助力公司战略执行")]), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hover-button', {
    attrs: {
      "clazz": "consult-button",
      "text": "立即咨询"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goConsult.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "purchase-section3",
    on: {
      "mouseleave": function($event) {
        return _vm.chooseTab('first')
      }
    }
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("切合采购需求，信息技术优化采购工作")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-main"
  }, [_c('div', {
    staticClass: "section3-choose"
  }, [_c('div', {
    staticClass: "left-list"
  }, _vm._l((_vm.collpaseItem), function(item) {
    return _c('div', {
      staticClass: "choice",
      class: _vm.choice === item.order ? 'is-choosed ' + item.order : item.order,
      on: {
        "mouseenter": function($event) {
          return _vm.chooseTab(item.order)
        }
      }
    }, [_c('div', {
      staticClass: "choice-content"
    }, [_c('div', {
      staticClass: "icon-container dib"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.icon),
        expression: "item.icon"
      }],
      staticClass: "icon",
      attrs: {
        "alt": item.text
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('div', {
      staticClass: "triangle"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, _vm._l((_vm.collpaseItem), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.choice === item.order),
        expression: "choice === item.order"
      }],
      key: item.order,
      class: item.order + '-content'
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, _vm._l((item.content), function(subitem) {
      return _c('p', [_vm._v(_vm._s(subitem))])
    }), 0), _vm._v(" "), _vm._l((item.url), function(subitem2) {
      return _c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (subitem2),
          expression: "subitem2"
        }],
        staticClass: "image",
        attrs: {
          "alt": subitem2
        }
      })
    })], 2)
  }), 0)])])])]), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("\n          采购在公司运营中发挥着关键作用。其任务是集中采购以实现节约"), _c('br'), _vm._v("\n          并加快审批速度，同时还专注于战略，创新和合规等责任。为了提"), _c('br'), _vm._v("\n          高整个组织的影响力，采购专业人员需要在控制支出和避免风险方"), _c('br'), _vm._v("\n          面具有战略智慧，同时推动盈利能力和收入增长的全局发展。甄云"), _c('br'), _vm._v("\n          采购管理系统解决方案使您能够在两者上都表现出色。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("您是否遇到过这些问题")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider"
  }), _vm._v(" "), _c('ul', {
    staticClass: "section2-list"
  }, [_c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-1-1@2x.png"),
      "alt": "供应商开发渠道单一"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("供应商开发渠道单一")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-1-2@2x.png"),
      "alt": "采购成本居高不下"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("采购成本居高不下"), _c('br'), _vm._v("降本增效压力大\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-2-1@2x.png"),
      "alt": "供应商管理缺乏根据，效率不高"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("供应商管理缺乏根据，效率不高")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-2-2@2x.png"),
      "alt": "采购周期长，成本高"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("采购周期长，成本高")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-3-1@2x.png"),
      "alt": "采购团队业务技能欠缺"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("采购团队业务技能欠缺")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item dib"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": require("../../assets/img/purchase/section2-3-2@2x.png"),
      "alt": "行业熟悉度不高，缺乏对市场的了解无法对供应商深度评估"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "item-misc"
  }, [_vm._v("行业熟悉度不高，缺乏对市场的了解无法对供应商深度评估")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-section4"
  }, [_c('div', {
    staticClass: "section4-content"
  }, [_c('h1', {
    staticClass: "section4-title"
  }, [_vm._v("采购甄云采购管理系统，您能得到什么？")]), _vm._v(" "), _c('div', {
    staticClass: "section4-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-boxlist"
  }, [_c('div', {
    staticClass: "box first"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchase/section4-1@2x.png"),
      "alt": "控制并降低采购成本"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("控制并降低采购成本")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("海量货源，及时高效选取供应商，通过集中采购...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("海量货源，及时高效选取供应商，通过集中采购，询比价助手，合理控制企业采购成本")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box second"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchase/section4-2@2x.png"),
      "alt": "保障采购进度按计划进行"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("保障采购进度按计划进行")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("采购进度能否按计划执行采购进度能否按计划执行采购进...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("采购进度能否按计划执行是一项关键因素，甄云采购系统，可实现向供应商催货，\n              并提前安排好物流，单证的准备，达到物料的准时交付，从而不影响生产进度")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box third"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchase/section4-3@2x.png"),
      "alt": "保障产品质量"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("保障产品质量")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("物料质量控制是基础，甄云系统通过供应商绩效评估报表...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("物料质量控制是基础，甄云系统通过供应商绩效评估报表，\n              清晰呈现忧虑，促进供应商质量提升")])]), _vm._v(" "), _c('div', {
    staticClass: "tail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box fourth"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/img/purchase/section4-4@2x.png"),
      "alt": "简化提升采购效率"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("简化提升采购效率")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "hidden-content"
  }, [_vm._v("简化采购工作流程，实现采购全过程的可见性，目录化...")]), _vm._v(" "), _c('p', {
    staticClass: "full-content"
  }, [_vm._v("简化采购工作流程，实现采购全过程的可见性，目录化商城快速找到采购商品，提升采购效率")])]), _vm._v(" "), _c('div', {
    staticClass: "tail-line"
  }, [_c('div', {
    staticClass: "tail"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152dd827"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/purchase.vue
// module id = 428
// module chunks = 12